import { ComponentF, ComponentO } from "../ui";

export const Container: ComponentF<{ children: ComponentO[] }> = (C, props) => {
  return props.children;
};
